import { Component, Input } from '@angular/core';
import { ClassNames } from '../../../constants/class-names.constants';
import { ICardTab } from '../../../models/common';

/**
 * @group Layout
 * @component Card Tabs
 *
 * @export
 * @class LsqCardTabsComponent
 * @property {ICardTab[]} [tabs] List of tabs that will be displayed on the page.
 */
@Component({
    selector: 'lsq-card-tabs',
    template: `
        <ng-container *ngIf="tabs?.length > 0">
            <div class="row">
                <div class="col">
                    <ul class="tabs nav nav-tabs">
                        <li class="nav-item" *ngFor="let tab of tabs; let i = index">
                            <a
                                class="nav-link"
                                [ngClass]="tab.active ? classNames.Active : ''"
                                (click)="handleClick(i)"
                            >
                                {{ tab.title }}
                            </a>
                        </li>
                    </ul>
                    <ng-container *ngIf="activeTab">
                        <div class="tab-content">
                            <ng-container
                                *ngIf="
                                    activeTab?.templateRef != null;
                                    then templateOutlet;
                                    else componentOutlet
                                "
                            ></ng-container>

                            <ng-template #templateOutlet>
                                <ng-container
                                    *ngTemplateOutlet="activeTab.templateRef"
                                ></ng-container>
                            </ng-template>

                            <ng-template #componentOutlet>
                                <ng-container
                                    *ngComponentOutlet="activeTab.component"
                                ></ng-container>
                            </ng-template>
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
    `,
    styleUrls: ['./lsq-card-tabs.component.scss']
})
export class LsqCardTabsComponent {
    @Input() public tabs: ICardTab[];
    public classNames = ClassNames;

    public handleClick(selectedIndex: number): void {
        this.tabs.forEach((tab, tabIndex) => {
            tab.active = selectedIndex === tabIndex;
        });
    }

    public get activeTab(): ICardTab {
        return this.tabs.find((tab) => tab.active);
    }
}
